import { TagField } from '@shared/data/entity/fields/TagField';

/**
 * A tag field as one line of text: the first tag's label, and a "+N" for any more. A value that
 * isn't one of the field's options reads as typed.
 */
export function getTagText(field: TagField): string {
  const [first, ...more] = field.tagIds.map(
    tagId => field.tagOptions.find(option => option.value === tagId)?.label ?? tagId,
  );
  const label = first ?? '';
  return more.length > 0 ? `${label} +${more.length}` : label;
}
